// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-881a79fb] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.user-status-icon[data-v-881a79fb] {
  --user-status-color-online: #2D7B41;
  --user-status-color-busy: #DB0606;
  --user-status-color-away: #C88800;
  --user-status-color-offline: #6B6B6B;
  display: flex;
  justify-content: center;
  align-items: center;
}
.user-status-icon--invisible[data-v-881a79fb] {
  filter: var(--background-invert-if-dark);
}
.user-status-icon[data-v-881a79fb] svg {
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/dialogs/node_modules/@nextcloud/vue/dist/assets/NcUserStatusIcon-B3aHoBAd.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,iCAAiC;EACjC,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-881a79fb] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.user-status-icon[data-v-881a79fb] {\n  --user-status-color-online: #2D7B41;\n  --user-status-color-busy: #DB0606;\n  --user-status-color-away: #C88800;\n  --user-status-color-offline: #6B6B6B;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.user-status-icon--invisible[data-v-881a79fb] {\n  filter: var(--background-invert-if-dark);\n}\n.user-status-icon[data-v-881a79fb] svg {\n  width: 100%;\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
